<template>
  <div class="banner">
    <div class="banner-iframe-wrapper">
      <div
        v-html="widget.code"
        :style="style"
      >
      </div>
    </div>

    <b-button
      class="modern-button banner-button--get-code"
      @click="onGetBannerCodeClick"
    >
      GET BANNER CODE
    </b-button>
  </div>
</template>

<script>
import { banner, bannerSendToEmail } from '@/api/widget';
import GetCodeWidget from '@/components/Modal/GetCodeWidget.vue';
import { mapMutations, mapState } from 'vuex';
import * as MUTATIONS from '@/store/mutations';

export default {
  name: 'BannerWidget',
  props: {
    widget: {
      default: () => ({}),
      required: true,
    },
    pageId: {
      type: Number,
      default: null,
    },
    hideLink: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      iframeListeners: [],
    };
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    style() {
      return {
        height: `${this.widget.params.height}px`,
        width: `${this.widget.params.width}px`,
      };
    },
  },
  methods: {
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    async onGetBannerCodeClick() {
      this.startLoading();

      try {
        const response = await banner(this.widget.bannerId, {
          pageId: this.pageId,
          width: this.widget.params.width,
          height: this.widget.params.height,
          userId: this.userId,
          hideLink: !this.hideLink ? 1 : 0,
        });

        this.openModal(response.data.code);
      } catch (e) {
        this.$buefy.snackbar.open({
          message: 'Something wrong',
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }

      this.finishLoading();
    },
    openModal(code) {
      const self = this;
      this.$buefy.modal.open({
        parent: this,
        component: GetCodeWidget,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'modern-fix-modal',
        canCancel: ['outside'],
        props: {
          active: true,
          code,
          emailSending: false,
          nameWidjet: 'Banner',
          nameWidjetFull: 'Banner',
        },
        events: {
          async submit(email) {
            await self.onModalSendEmailClick(email);
          },
        },
      });
    },
    async onModalSendEmailClick(email) {
      this.startLoading();

      try {
        const response = await bannerSendToEmail(this.widget.bannerId, {
          pageId: this.pageId,
          width: this.widget.params.width,
          height: this.widget.params.height,
          userId: this.userId,
          hideLink: !this.hideLink ? 1 : 0,
          email,
        });

        if (response.status === 200) {
          this.$buefy.toast.open({ message: 'Success!', type: 'is-success', duration: 3000 });
        }
      } catch (e) {
        this.$buefy.snackbar.open({
          message: 'Something wrong',
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }

      this.finishLoading();
    },
  },
  mounted() {
    this.iframeListeners = [];

    const iframe = this.$el.querySelector('iframe');

    const handleComplete = () => {
      this.$emit('load');
    };

    iframe.addEventListener('load', handleComplete);
    iframe.addEventListener('error', handleComplete);

    this.iframeListeners.push({
      iframe,
      handleComplete,
    });
  },
  beforeDestroy() {
    this.iframeListeners.forEach(({ iframe, handleComplete }) => {
      iframe.removeEventListener('load', handleComplete);
      iframe.removeEventListener('error', handleComplete);
    });
  },
};
</script>

<style lang="stylus">
.marketing-materials.banners .banner
  margin 25px 17.5px
  max-width 100%
  & .banner-iframe-wrapper
    overflow-x auto
    overflow-y hidden
  & .banner-button--get-code
    margin-top 10px
    @media(max-width 499px)
      width 100%
  & iframe
    width 100%
    height 100%
</style>
